import React from 'react';

import { ProfilePictureModalWrapper } from '../profile-picture-upload-modal';
import { ProfilePictureForm } from './component/profile-picture-upload';

export const ProfilePictureUpload = () => {
    return (
        <ProfilePictureModalWrapper>
            <ProfilePictureForm />
        </ProfilePictureModalWrapper>
    );
};
